import {useEffect, useState, useRef, useMemo } from 'react';
import {Heading,HEADING_TYPES, DatePicker, ChoiceChips} from 'cdk-radial'
import { CommonDropdown } from "../../common/CommonSelector";
import { MultiSelectDropdownMenu } from '../../common/MultiSelectDropdownMenu';
import { useDashboardData } from '../useDashboard';
import { accountingARUrl,  } from '../DashboardConfig';
import { APP_ENV } from '../../../constants';
import userProfileStore from '../../core/UserProfileStore';
import useUserSettingStore from '../UserSettingStore';
import {AR_DASHBOARD} from '../useARDashboard';
import styled from 'styled-components';
import { useTranslation } from "react-i18next";
import moment from 'moment';

export const getScheduleCode = (
  franchise: string,
  primaryStore: string,
  storeIds: string[],
  enterpriseId: any
) => {
  const config = [];
  config.push({
    id: 'schedules',
    apiConfig: {
      method: 'GET',
      headers: {
        'x-franchise-id': franchise,
        'x-department-name': 'ACCOUNTING',
        'x-department-type': 'A',
        'x-store-id': primaryStore,
        'x-enterprise-id': enterpriseId,
      },
      queryParams: {
        storeId: storeIds,
      },
      path: '/accounts-receivable/schedules',
      endpoint:
        accountingARUrl[APP_ENV as unknown as keyof typeof accountingARUrl],
    },
  });
  return config;
};

export const getGroups = () => {
  const config = [];
  config.push({
    id: 'group',
    apiConfig: {
      method: 'GET',
      headers: {
        'x-department-name': 'ACCOUNTING',
        'x-department-type': 'A',
      },
      path: '/user-details/v3',
      endpoint:
        accountingARUrl[APP_ENV as unknown as keyof typeof accountingARUrl],
    },
  });
  return config;
};

export const getLastStatementDate = (
  franchise: string,
  primaryStore: string,
  storeIds: string[],
  enterpriseId: any
) => {
  const config = [];
  config.push({
    id: 'lastStatementDate',
    apiConfig: {
      method: 'GET',
      headers: {
        'x-franchise-id': franchise,
        'x-department-name': 'ACCOUNTING',
        'x-department-type': 'A',
        'x-store-id': primaryStore,
        'x-enterprise-id': enterpriseId,
      },
      queryParams: {
        storeId: storeIds,
      },
      path: '/accounts-receivable/arDashBoard/getLastStatementDate',
      endpoint:
        accountingARUrl[APP_ENV as unknown as keyof typeof accountingARUrl],
    },
  });
  return config;
};


const getScheduleSetting = (
  filter: any,
  allGroup: any,
) => {
    
  const defaultGroup = allGroup?.find((group: any) => group.default === true);
  const franchise = defaultGroup?.storeInfoList[0]?.franchiseId;
  const primaryStore = defaultGroup?.primaryStore;
  const defaultStoreIds = defaultGroup?.storeInfoList?.map(
    (store: any) => store.storeId
  );

    if (filter) {
        return {
            storeIds: filter.storeIds,
            group: filter.group,
            franchise: filter.group?.storeInfoList?.[0]?.franchiseId,
            primaryStore: filter.group?.primaryStore,
        };
    }

  return {
    storeIds: defaultStoreIds,
    group: defaultGroup,
    franchise: franchise,
    primaryStore: primaryStore
  };
};

export const StyledFieldRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  @media (max-width: 1100px) {
    display: grid;
    max-width: 70%;
  }
`;

export const StyledDatePickerWrapper = styled.div<{ maxWidth?: string }>`
  max-width: ${(props) => props.maxWidth || '250px'};
  width: 100%;
  position: relative;
  .DayPicker {
    position: absolute;
    top: 100%;
    z-index: 1000;
  }
`;

export const DatePresetChipGroup = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  // flex: 1;
  min-width: 300px;
  
  @media (max-width: 768px) {
    min-width: 100%;
  }
`;


const getARFilterSetting = (
  filter: any,
  allGroup: any,
  scheduleCodes: any,
  widgetId?: string
) => {
  const defaultGroup = allGroup?.find((group: any) => group.default === true);

  const franchise = defaultGroup?.storeInfoList[0]?.franchiseId;
  const primaryStore = defaultGroup?.primaryStore;
  const defaultStoreIds = defaultGroup?.storeInfoList?.map(
    (store: any) => store.storeId
  );

    if (filter) {
        // Both widgets now use the same date properties
        const reportDate = filter.reportDate !== undefined ? filter.reportDate : undefined;
        const reportDaysAgo = filter.reportDaysAgo !== undefined ? filter.reportDaysAgo : 1;
        
        return {
            storeIds: filter.storeIds,
            group: filter.group,
            franchise: filter.group?.storeInfoList?.[0]?.franchiseId,
            primaryStore: filter.group?.primaryStore,
            scheduleCodes: scheduleCodes,
            reportDate: reportDate,
            reportDaysAgo: reportDaysAgo
        };
    }

  return {
    storeIds: defaultStoreIds,
    group: defaultGroup,
    franchise: franchise,
    primaryStore: primaryStore,
    scheduleCodes:scheduleCodes,
    reportDate: undefined,
    reportDaysAgo: 1 // Default to "Today" for first-time users
  };
};

export const useARDashboardFilter = ({userSetting, widgetId, enabled = true}:any) => {

    const { enterpriseId  } = userProfileStore();

    const [groupConfig, setGroupConfig] = useState<any>(null);
    const [scheduleCodeConfig, setScheduleCodeConfig] = useState<any>(null);
    const [filterSetting, setFilterSetting] = useState() as any;

    // Use single shared dashboard ID for both widgets
    const dashboardId = AR_DASHBOARD.DASHBOARD_ID;

    const userAppliedFilter = userSetting.dashboard?.find((d: any) => d.id === dashboardId)?.filter;

    const groupData = useDashboardData({
        config: groupConfig,
        enabled: !!groupConfig,
    });

    const scheduleCodeData = useDashboardData({
        config: scheduleCodeConfig,
        enabled: !!scheduleCodeConfig,
    });

    useEffect(() => {
      if (!enabled) {
        setGroupConfig(null);
        setScheduleCodeConfig(null);
        setFilterSetting(undefined);
        return;
      }
      setGroupConfig(getGroups());
    }, [enabled]);

    useEffect(() => {
        if (groupData?.rawData?.[0]) {
            const rawData = groupData?.rawData?.[0];
            const allGroup = rawData?.groupInfoList;
            const config = getScheduleSetting(userAppliedFilter, allGroup);
            setScheduleCodeConfig(
                getScheduleCode(config.franchise,config.primaryStore,config.storeIds,enterpriseId)
            );
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userSetting, groupData?.rawData?.[0], enterpriseId]);

    useEffect(() => {
        if (scheduleCodeData?.rawData?.[0] && groupData?.rawData?.[0]) {
            const rawData = groupData?.rawData?.[0];
            const allGroup = rawData?.groupInfoList;
            const scheduleCodes = scheduleCodeData.rawData[0].scheduleCodesList?.map(
                (c: any) => c.scheduleCode
            )
            setFilterSetting(getARFilterSetting(userAppliedFilter, allGroup, scheduleCodes, widgetId));
        }else if (scheduleCodeData?.error && groupData?.rawData?.[0]) {
            const rawData = groupData?.rawData?.[0];
            const allGroup = rawData?.groupInfoList;
            setFilterSetting(getARFilterSetting(userAppliedFilter, allGroup, null, widgetId));
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSetting,scheduleCodeData?.error,scheduleCodeData?.rawData?.[0], groupData?.rawData?.[0], widgetId]);

  const isGroupLoading = !!groupConfig && groupData.isLoading;
  const isScheduleLoading = !!scheduleCodeConfig && scheduleCodeData.isLoading;
  const isFilterPending = !filterSetting;
  const isLoading = enabled &&
    !groupData?.error &&
    !scheduleCodeData?.error &&
    (isGroupLoading || isScheduleLoading || isFilterPending);

  return {
    isLoading,
    error: groupData?.error || scheduleCodeData?.error,
    filterSetting: filterSetting
  };

}

export const ARFilter = ({ onChange, onValidationError, widget }: any) => {

    const { userSetting } = useUserSettingStore();
    const {isLoading , filterSetting} = useARDashboardFilter({userSetting, widgetId: widget?.id});

    const [groupConfig, setGroupConfig] = useState<any>(null);
    const {t} = useTranslation();
    
    // Get the current saved filter from userSetting to preserve all properties
    // Both widgets use the SAME dashboard ID to share the filter
    const dashboardId = AR_DASHBOARD.DASHBOARD_ID;
    const existingFilter = userSetting.dashboard?.find((d: any) => d.id === dashboardId)?.filter || {};

    const groupData = useDashboardData({
        config: groupConfig,
        enabled: !!groupConfig,
    });

    const [groupOptions,setGroupOptions] = useState() as any;
    const [selectGroup, setSelectGroup] = useState() as any;

    const [storeOptions, setStoreOptions] = useState([]) as any;
    const [selectStore, setSelectStore] = useState([]) as any;

    // Date filter state
    const [selectedDate, setSelectedDate] = useState<any>(null);
    const [datePreset, setDatePreset] = useState<string>('custom');

    // Block future dates from tomorrow onwards
    const blockedFutureDates = useMemo(() => [
        {
            startDate: moment().add(1, 'day'),
            endDate: moment('2100-12-31')
        }
    ], []);
    
    // Disable save button while loading data or if no stores selected
    useEffect(() => {
        onValidationError(isLoading || selectStore.length === 0);
    }, [isLoading, selectStore, onValidationError]);

    // Validate date selection: require either a valid date OR a preset (not custom), and stores must be selected
    useEffect(() => {
        // Check if selected date is in the future
        if (selectedDate && moment(selectedDate).isAfter(moment(), 'day')) {
            onValidationError(true);
        }
        // If no date selected and no preset selected, or no stores selected, disable save
        else if ((!selectedDate && datePreset === 'custom') || selectStore.length === 0) {
            onValidationError(true);
        }
        else if (!isLoading) {
            // Only enable if not loading, stores are selected, and valid date/preset
            onValidationError(false);
        }
    }, [selectedDate, datePreset, isLoading, selectStore, onValidationError]);
    
    const tempDateRef = useRef<any>(null);

    // Initialize
    useEffect(() => {
      setGroupConfig(getGroups());
    }, []);

   useEffect(()=>{ 
    
    const rawData = groupData?.rawData?.[0];
    const allGroup = rawData?.groupInfoList;

    if( filterSetting?.group){
      const options = allGroup?.map((group:any) => {
        return {
          value: group?.groupName,
          label: group?.groupName,
          obj: group
        }
      });
      setGroupOptions(options);
      const go = options?.find((o:any) => o.label === filterSetting.group.groupName);
      setSelectGroup(go);

      const storeOptions = filterSetting.group.storeInfoList?.map((store:any) =>{
         return {
          value: store?.storeId,
          label: store?.storeName,
          obj: store
        }
      });
      setStoreOptions(storeOptions);
      const storesSelc = storeOptions?.filter((s:any) => filterSetting.storeIds?.includes(s?.value));
      setSelectStore(storesSelc);
      if(storesSelc.length === 0){
            onValidationError(true);
        }else{
            onValidationError(false);
        }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isLoading,filterSetting,groupData?.rawData?.[0]?.groupInfoList]);

  // Update date preset whenever filterSetting changes (including modal reopening)
  useEffect(() => {
    if (!filterSetting) return;
    
    // Convert reportDaysAgo to number in case it's a string
    const daysAgo = Number(filterSetting.reportDaysAgo);
    
    // Check if reportDate is truthy and not empty string
    const hasReportDate = filterSetting.reportDate && filterSetting.reportDate !== '';
    
    // If Last Statement (daysAgo is 0 and no explicit date yet), show preset button
    if (!hasReportDate && daysAgo === 0) {
      setSelectedDate(null);
      setDatePreset('laststatement');
    } else if (hasReportDate) {
      // Custom date selected via date picker
      const savedDate = moment(filterSetting.reportDate);
      setSelectedDate(savedDate);
      tempDateRef.current = savedDate;
      setDatePreset('custom');
    } else {
      if (!isNaN(daysAgo) && daysAgo > 0) {
        setSelectedDate(null);
        
        if (daysAgo === 1) {
          setDatePreset('today');
        } else if (daysAgo === 7) {
          setDatePreset('7days');
        } else if (daysAgo === 14) {
          setDatePreset('14days');
        } else {
          setDatePreset('today'); // Default fallback
        }
      } else {
        // Default for first-time users or invalid value
        setSelectedDate(null);
        setDatePreset('today');
      }
    }
  }, [filterSetting, widget?.id]);

  const handleSelectGroup = (group: any) => {
      const rawGroup = group?.obj;
      const newStoreOptions = rawGroup?.storeInfoList?.map((store: any) => ({
        value: store?.storeId,
        label: store?.storeName,
        obj: store
      })) || [];

      setStoreOptions(newStoreOptions);
      setSelectStore([]);
      setSelectGroup(group);

      // Determine date values
      let dateValue = null;
      let daysAgoValue = 0;
      
      if (selectedDate) {
        dateValue = selectedDate.format('YYYY-MM-DD');
      } else if (datePreset !== 'custom') {
        if (datePreset === 'today') daysAgoValue = 1;
        else if (datePreset === '7days') daysAgoValue = 7;
        else if (datePreset === '14days') daysAgoValue = 14;
        else if (datePreset === 'laststatement') {
          daysAgoValue = 0;
        }
      }

      // Shared filter - both widgets use same date properties
      const updateData: any = {
        ...existingFilter,
        group: group?.obj,
        storeIds: [],
        reportDate: dateValue,
        reportDaysAgo: daysAgoValue
      };
      
      onChange(updateData);

      onValidationError(true);

    };

    const handleSelectStore = (selectedStores: any) => {
        setSelectStore(selectedStores);

        // Determine date values
        let dateValue = null;
        let daysAgoValue = 0;
        
        if (selectedDate) {
          dateValue = selectedDate.format('YYYY-MM-DD');
        } else if (datePreset !== 'custom') {
          if (datePreset === 'today') daysAgoValue = 1;
          else if (datePreset === '7days') daysAgoValue = 7;
          else if (datePreset === '14days') daysAgoValue = 14;
          else if (datePreset === 'laststatement') {
            daysAgoValue = 0;
          }
        }

        // Shared filter - both widgets use same date properties
        const updateData: any = {
          ...existingFilter,
          group: selectGroup?.obj,
          storeIds: selectedStores?.map((store:any) => store.value),
          reportDate: dateValue,
          reportDaysAgo: daysAgoValue
        };
        
        onChange(updateData);

        if(selectedStores.length === 0){
            onValidationError(true);
        }else{
            onValidationError(false);
        }
    };

    const handleDateChange = (date: any) => {
        setSelectedDate(date);
        tempDateRef.current = date;
        setDatePreset('custom'); // Reset preset when date is selected
        
        // Shared filter - both widgets use same date properties
        const updateData: any = {
          ...existingFilter,
          group: selectGroup?.obj,
          storeIds: selectStore?.map((store:any) => store.value),
          reportDate: date ? date.format('YYYY-MM-DD') : null,
          reportDaysAgo: 0
        };
        
        onChange(updateData);
    };

    const handleDatePreset = (preset: string) => {
        setDatePreset(preset);
        setSelectedDate(null); // Reset date picker when preset is selected
        tempDateRef.current = null; // Clear temp ref
        
        let daysAgo;
        switch(preset) {
            case 'today':
                daysAgo = 1;
                break;
            case '7days':
                daysAgo = 7;
                break;
            case '14days':
                daysAgo = 14;
                break;
            case 'laststatement':
                daysAgo = 0;
                break;   
            default:
                return;
        }
        
        // Shared filter - both widgets use same date properties
        // Save reportDaysAgo without explicit reportDate
        // useARDashboard will automatically fetch Last Statement date when reportDaysAgo=0
        const updateData: any = {
          ...existingFilter,
          group: selectGroup?.obj,
          storeIds: selectStore?.map((store:any) => store.value),
          reportDate: null,
          reportDaysAgo: daysAgo
        };
        
        onChange(updateData);
    };


  return (
        <div >
         {isLoading  && <div>Loading...</div>}
         {!isLoading  && 
           <>
             <div style={{marginBottom:'10px'}}>
                <Heading level={3} type={HEADING_TYPES.SUBTITLE_3} >
                    Date Settings
                </Heading>            
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', flexWrap: 'wrap', marginTop: '10px'}}>    
                <DatePresetChipGroup>
                    <ChoiceChips
                        dataTestId="date-preset-chips"
                        onClick={(value: string) => handleDatePreset(value)}
                        id="date-preset-chips"
                        name="datePreset"
                        options={[
                            { label: t('dashboard.datePresets.today') as string, value: 'today' },
                            { label: t('dashboard.datePresets.7daysAgo') as string, value: '7days' },
                            { label: t('dashboard.datePresets.14daysAgo') as string, value: '14days' },
                            { label: t('dashboard.datePresets.lastStatement') as string, value: 'laststatement' }
                        ]}
                        value={datePreset === 'custom' ? '' : datePreset}
                        isDisabled={isLoading}
                    />
                </DatePresetChipGroup>
                     
                <StyledDatePickerWrapper maxWidth="250px" style={{ flex: '0 0 250px' }}>
                    <DatePicker
                        dataTestId="ar-filter-date-picker"
                        date={selectedDate}
                        dateFormat="MM/DD/YYYY"
                        dateInputProps={{
                            enableCustomValidation: false,
                            errorMessage: '',
                            hasError: false,
                            isReadOnly: false,
                            isRequired: false,
                            isDisabled: isLoading,
                            size: 'standard',
                            onError: () => {},
                        }}
                        allowDaysInPast={true}
                        blockedDateRanges={blockedFutureDates}
                        id="ar-filter-date-picker"
                        label={(t('dashboard.settings.selectDate', { defaultValue: 'Select Date' }) as any)}
                        maximumYear={2100}
                        minimumYear={1900}
                        name="ar-filter-date-picker"
                        numberOfMonths={1}
                        onDateChange={handleDateChange}
                        shortcutChipsPosition="none"
                    />
                </StyledDatePickerWrapper>
            </div>
          </div>
            <Heading level={3} type={HEADING_TYPES.SUBTITLE_3} >{t('dashboard.settings.filterTitle')} (Account Receivable Payment & Aging)</Heading>
            <div style={{marginTop:'5px'}}>

                <StyledFieldRow>
                    <div style={{ flex: 1 }}>
                        <CommonDropdown
                    options={groupOptions || []}
                    name="franchise"
                    label={t('dashboard.settings.selGroup') as any}
                    placeholder=""
                    selectedOption={selectGroup}
                    isRequired={true}
                    onSelect={handleSelectGroup} />
                    </div>
                    <div style={{ flex: 1, marginTop:'-10px' }}>
                    <MultiSelectDropdownMenu
                      hasError={selectStore.length === 0}
                      options={storeOptions || []}
                      isRequired={true}
                      name="Stores"
                      onSelect={handleSelectStore}
                      value={selectStore}
                      label={t('dashboard.settings.selStore') as any}
                      placeholder={t('dashboard.settings.selStore') as any}
                    />
                    </div>
                </StyledFieldRow>
            </div>
            </>}
        </div>
  );
};
